/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

/**
 * Contract side
 */
export type AmendOrderDtoSide = (typeof AmendOrderDtoSide)[keyof typeof AmendOrderDtoSide];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AmendOrderDtoSide = {
  yes: 'yes',
  no: 'no',
} as const;
